// StripeのタイムスタンプをDateに変換する(時差補正とミリ秒化)
const stripeTimestampToDate = (timestamp: number): Date => {
  return new Date(timestamp * 1000 + 9 * 60 * 60 * 1000);
};

export default stripeTimestampToDate;
